<template>
    <div class="page-404">
<!--        <p>Ой! Кудись сторінка зникла!</p>-->

<!--        <div>-->
<!--            Можливо, вона змінила адресу, або її взагалі не існувало! Головне не панікувати 😉 <br>-->

<!--            Скористайтеся пошуком або поверніться на головну <br>-->

<!--            TOUS завжди поруч! <br>-->
<!--        </div>-->
        <div v-html="result.html"></div>
        <DefVideo
                v-if="result.video && $store.state.global.screenWidth < 768"
                :result="result.video"
        />
    </div>
</template>

<script>
    import DefVideo from "../Def/DefVideo/DefVideo.vue";

    export default {
        name: "Page404",
      components: {DefVideo},
        selector: '.page-404',
        props: ['result']
    }
</script>

<style lang="scss" scoped>
.page-404 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 60px 0 95px 0;
    :deep {
        p {
            font-weight: 600;
        }
        .def-video {
            margin: auto;
        }
    }
}
</style>